import { __decorate } from "tslib";
import User from '@/plugins/graphql/queries/me.gql';
import { Component, Mixins } from 'vue-property-decorator';
let PendingOrderReminder = class PendingOrderReminder extends Mixins() {
    constructor() {
        super(...arguments);
        this.me = {};
    }
    get8thOfMonth() {
        const today = new Date();
        const lastDay = new Date(today.getFullYear(), today.getMonth(), 8);
        const month = lastDay.toLocaleString('en-US', { month: 'long' });
        const day = lastDay.getDate();
        const year = lastDay.getFullYear();
        return `${month} ${day}, ${year}`;
    }
};
PendingOrderReminder = __decorate([
    Component({
        components: {},
        apollo: {
            me: {
                query: User,
            },
        },
    })
], PendingOrderReminder);
export default PendingOrderReminder;
